import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _20_AESTHETHIC:Partial<EcosystemServiceModel> ={
  id:'aesthetic',
  pos:20,
  image: "/images/ecoservices/aesthetic.jpg",
  code: ["3.1.2.4"],
  unit:'aesthetic experiences',
  assetType:'socialUses',
  serviceType: 'cultural',
  valuationMethods:[
    {
      id: 'travelcost',
      name:"Travel Cost",
      unit: "visitor",
      element: "Visitors",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    },
    {
      id: 'contingent',
      name:"Contingent Valuation",
      unit: "person",
      element: "Population",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    },
    {
      id: 'project',
      name:"Project Budget",
      unit: "projects",
      element: "Projects",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]

}
